module.exports = __webpack_public_path__ + "components/page-header/static/icon-heart-fill-9bef7cddcbbf942fc8225c9543baab49.svg";